import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { TextMaskModule } from 'angular2-text-mask';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';

import { AddressComponent } from './address/address.component';
import { SummaryComponent } from './summary/summary.component';
import { CheckoutComponent } from './checkout.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';

import { RouterModule } from '@angular/router';

import { CartService } from '../cart/cart.service';
import { ModalService } from '../modal/modal.service';
import { CheckoutService } from './checkout.service';
import { ConfirmationGuard } from './confirmation/confirmation-guard.service';
import { AddressGuard } from './address/address-guard.service';
import { AppHttpService } from '../app-http.service';
import { Validator } from './checkout.validations';
import { CouponComponent } from './coupon/coupon.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { LimitComponent } from './limit/limit.component';
import { LoginAlertComponent } from './login-alert/login-alert.component';

@NgModule({
  declarations: [
    AddressComponent,
    SummaryComponent,
    CheckoutComponent,
    ConfirmationComponent,
    CouponComponent,
    LimitComponent,
    LoginAlertComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TextMaskModule,
    NguiAutoCompleteModule,
    RouterModule,
    NgbTooltipModule
  ],
  exports: [AddressComponent, SummaryComponent, LoginAlertComponent],
  providers: [
    CartService,
    CheckoutService,
    AppHttpService,
    Validator,
    ConfirmationGuard,
    AddressGuard,
    ModalService
  ]
})
export class CheckoutModule {}
